import { render, staticRenderFns } from "./AllParentMessages.vue?vue&type=template&id=288d0550&scoped=true&"
import script from "./AllParentMessages.vue?vue&type=script&lang=js&"
export * from "./AllParentMessages.vue?vue&type=script&lang=js&"
import style0 from "./AllParentMessages.vue?vue&type=style&index=0&id=288d0550&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288d0550",
  null
  
)

export default component.exports